module.exports = __webpack_public_path__ + "static/media/Brand.e221e3c9.jpg";